import http from '@/services/http/index'
import endpoints from '@/services/http/endpoints'

export default {
  payment(data) {
    return http.post(endpoints.get('payment'), data)
  },
  paymentStatus(sessionId) {
    return http.get(endpoints.get('paymentStatus', { sessionId }))
  },
  getInstallmentsPayment(hash) {
    return http.get(endpoints.get('installmentsPayment', { hash }))
  },
  postInstallmentsPayment(hash) {
    return http.post(endpoints.get('installmentsPayment', { hash }))
  }
}
